import { Link } from "react-router-dom";

const TopNavigationListItem3 = ({ listItemTitle, listItemLink, itemStyle, classNames }) => {

  return (
    /** <Nav.Link /> vs <Link />: refresh vs redirect */
    <Link to={listItemLink} className={classNames!=null ? classNames + " topNavMenuItem" : "topNavMenuItem"} style={itemStyle}>
      {listItemTitle}
    </Link>
  )
}

export default TopNavigationListItem3;